
define('text!templates/modules/goal/goal.html',[],function () { return '<div class="goal" id="goal-module">\n    <ul class="menu-actions nav nav-pills"></ul>\n    <div class="alert-no-data"></div>\n    <div class="goal-list"></div>\n</div>\n';});

